import { PanoramaRede } from "../../components/panorama/PanoramaRede.tsx";
import type { Panorama as PanoramaData } from "../../lib/panorama.ts";
import { PageHeader } from "../ui/kit.tsx";

/** Wrapper desktop do Panorama da Rede (comparativo entre unidades). */
export function PanoramaDesktop({ panorama }: { panorama: PanoramaData | null }) {
  return (
    <div className="dk-page" style={{ maxWidth: 1320 }}>
      <div
        className="no-print"
        style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        <PageHeader titulo="Panorama da Rede" sub="Comparativo entre unidades" />
        {panorama ? (
          <button type="button" className="m-btn" onClick={() => window.print()}>
            🖨 Imprimir / PDF
          </button>
        ) : null}
      </div>
      {panorama ? (
        <PanoramaRede panorama={panorama} />
      ) : (
        <p className="spec">Panorama disponível apenas para a gestão da rede.</p>
      )}
    </div>
  );
}
